export default "__VITE_ASSET__r75J3hMJ__"